import type { SVGProps } from "react";

export function DeskIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="-2.4 -0.6 28.8 28.8" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fill="currentColor"
        d="M23.5 21h-7a.5.5 0 0 0-.5.5v1a1.5 1.5 0 0 0 1.5 1.5h5a1.5 1.5 0 0 0 1.5-1.5v-1a.5.5 0 0 0-.5-.5m-1-9.5H11.75a.25.25 0 0 1-.25-.25v-1a.25.25 0 0 1 .25-.25H16a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h4.25a.25.25 0 0 1 .25.25v1a.25.25 0 0 1-.25.25H1.5A1.5 1.5 0 0 0 0 13v10a1 1 0 0 0 2 0v-7.5a.5.5 0 0 1 .5-.5h21a.5.5 0 0 0 .5-.5V13a1.5 1.5 0 0 0-1.5-1.5M5 2h11v6H5Z"
      />
      <path fill="currentColor" d="M16.5 16.5h7s.5 0 .5.5v2s0 .5-.5.5h-7s-.5 0-.5-.5v-2s0-.5.5-.5" />
    </svg>
  );
}
